/**
 * Parent Dashboard Layout
 * Carbon UI Shell compliant navigation system
 * Uses the unified CarbonUIShell for full Carbon compliance
 */

import React from 'react';
import CarbonUIShell from '../components/layout/CarbonUIShell';

interface ParentDashboardLayoutProps {
  children?: React.ReactNode;
}

const ParentDashboardLayout: React.FC<ParentDashboardLayoutProps> = ({ children }) => {
  return <CarbonUIShell>{children}</CarbonUIShell>;
};

export default ParentDashboardLayout;
